import iconeTipoVeiculoCarro from '@/assets/tiposVeiculos/icones/automovel.png';
import iconeTipoVeiculoMoto from '@/assets/tiposVeiculos/icones/moto.png';
import iconeTipoVeiculoUtilitario from '@/assets/tiposVeiculos/icones/utilitario.png';
import iconeTipoVeiculoCaminhao from '@/assets/tiposVeiculos/icones/caminhao.png';
import iconeTipoVeiculoCaminhonete from '@/assets/tiposVeiculos/icones/caminhonete.png';

export default class TiposVeiculosConstant {
    static MOTO = 'moto';
    static AUTOMOVEL = 'automovel';
    static UTILITARIO = 'utilitario';
    static CAMINHAO = 'caminhao';
    static CAMINHONETE = 'caminhonete';

    static TODOS = [
        {
            chave: TiposVeiculosConstant.AUTOMOVEL,
            descricao: 'Automóvel',
            imagem: iconeTipoVeiculoCarro
        },
        {
            chave: TiposVeiculosConstant.MOTO,
            descricao: 'Moto',
            imagem: iconeTipoVeiculoMoto
        },
        {
            chave: TiposVeiculosConstant.UTILITARIO,
            descricao: 'Utilitário',
            imagem: iconeTipoVeiculoUtilitario
        },
        {
            chave: TiposVeiculosConstant.CAMINHAO,
            descricao: 'Caminhão',
            imagem: iconeTipoVeiculoCaminhao
        },
        {
            chave: TiposVeiculosConstant.CAMINHONETE,
            descricao: 'Caminhonete',
            imagem: iconeTipoVeiculoCaminhonete
        }
    ];
}